import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatMessage } from '@/api/ChatApi';

interface SliceState {
	chatMessages: ChatMessage[];
}

const initialState: SliceState = {
	chatMessages: [
		{
			id: crypto.randomUUID(),
			role: 'assistant',
			content: 'Cześć! Jestem Twoim asystentem AI. Jak mogę Ci pomóc?',
			createdAt: new Date().toISOString(),
		},
	],
};

export const chatSlice = createSlice({
	name: 'chat',
	initialState,
	reducers: {
		insertMessage: (state, { payload }: PayloadAction<ChatMessage>) => {
			state.chatMessages.push(payload);
		},
	},
});

export const chatActions = chatSlice.actions;
export default chatSlice.reducer;
